// extracted by mini-css-extract-plugin
export var compactFilters = "_gz-4";
export var detailImage = "_gz-1";
export var dropdownContainer = "_gz-2";
export var imageContainer = "_gz-0";
export var selectedCard = "_gz-3";